import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/animations.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installApiFetch } from './api/session';
import { installFrDisplay } from './utils/frDisplay';
import { installEnDisplay } from './utils/enDisplay';
import { installTableExport } from './utils/tableExport';
import { installLoadingDecorator } from './utils/loadingDecorator';

// Routage par chemin (BrowserRouter) : les anciens liens « /#/chemin?x » restent valides
if (typeof window !== 'undefined' && window.location.hash.startsWith('#/')) {
  window.history.replaceState(null, '', window.location.hash.slice(1));
}

// Cookie de session HttpOnly + en-tête anti-CSRF sur tous les appels API (avant tout rendu)
installApiFetch();
installFrDisplay(); // valeurs techniques (statuts, types…) affichées en français
installEnDisplay(); // interface en anglais si l'utilisateur l'a choisi
installLoadingDecorator(); // roue animée sur chaque texte « Chargement… »
installTableExport(); // bouton « Exporter (Excel) » sur chaque tableau de données


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();

// Application installable (PWA) : uniquement en production, l'interface seule est mise en cache (jamais l'API)
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => {}); });
}

